module.exports = __webpack_public_path__ + "img/img-22.5bb1b356.png";